
(function() {
    'use strict';

	var BusinessSearchCtrl = function ($scope, $http) {
        $scope.formModel = {
            businessName : ""
        };
        $scope.businessRecords =[];
        $scope.getBusinessNames = function(managerId) {
            $scope.businessRecords = {};
            $http.get( WEBAPP_PATH + '/businessRecord/businessRecordsForManager/'+managerId+"?term="+encodeURIComponent($scope.formModel.businessName)).then(
                function(response){
                    var objectArr = [];
                    angular.forEach(response.data, function(resp){
                        console.log(resp.name);
                        objectArr.push({
                            id:         resp.id,
                            linked:     resp.linked,
                            name:       resp.name,
                            businessId: resp.businessId,
                            postcode:   resp.postcode
                        });
                    });
                    $scope.businessRecords = objectArr;
                }
            );
        }
    }

    BusinessSearchCtrl.$inject = ['$scope', '$http'];
    angular.module('app').controller('BusinessSearchCtrl',BusinessSearchCtrl);
}());